export const locales = [
	{ label: 'Nederlands', locale: 'nl' },
	{ label: 'English', locale: 'en' },
	{ label: 'Deutsch', locale: 'de' },
];

export const localeSelector = (state) => {
	return (state.init && state.init.i18n && state.init.i18n.language) || '';
};
